"use client";

import { memo, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Colorful } from "@uiw/react-color";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

interface ColorPickerInputProps {
  id: string;
  label: string;
  color: string;
  error?: string;
  onColorChange: (color: string) => void;
}

export const ColorPickerInput = memo(function ColorPickerInput({
  id,
  label,
  color,
  error,
  onColorChange,
}: ColorPickerInputProps) {
  const [isOpen, setIsOpen] = useState(false);

  const isValidHexColor = (c: string): boolean => {
    return /^#[0-9A-Fa-f]{6}$/.test(c);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <div className="flex gap-2">
        <div
          className="w-20 h-10 rounded border"
          style={{
            backgroundColor: isValidHexColor(color) ? color : "#CCCCCC",
          }}
        />
        <div className="flex-1">
          <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger asChild>
              <Input
                id={id}
                type="text"
                value={color}
                onChange={(e) => onColorChange(e.target.value)}
                placeholder="#FF0000"
                className={
                  error ? "border-red-500 cursor-pointer" : "cursor-pointer"
                }
              />
            </PopoverTrigger>
            <PopoverContent
              className="w-auto p-3 z-70"
              side="top"
              onOpenAutoFocus={(e) => e.preventDefault()}
            >
              <Colorful
                color={color}
                disableAlpha={true}
                onChange={(colorObj) => onColorChange(colorObj.hex)}
              />
            </PopoverContent>
          </Popover>
          {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
        </div>
      </div>
    </div>
  );
});
